/* eslint-disable import/no-cycle */
/* eslint-disable react/require-default-props */
import { Box, HStack, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger, Text } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import theme from '../../../../styles/customTheme';
import { useGetItemProperty } from '../hooks/useGetItemProperty';

interface InputPreviewProps {
  value?: string;
  fieldId: string;
  rightContent?: React.ReactNode;
}
const InputPreview = React.memo(
  function ({ fieldId, rightContent, value }: InputPreviewProps) {
    const { t } = useTranslation('hrFormTemplate');
    const currentFieldValue = useGetItemProperty<{ placeholder?: string }>(fieldId, 'previewPlaceholders'); // Uses renamed prop
    return (
      <Box
        backgroundColor="#F3F6F9"
        borderRadius={theme.radii.md}
        padding={theme.space[2]}
        display="flex"
        className="hide-in-drag-preview"
      >
        <HStack justify="space-between" align="center" w="100%">
          <Popover placement="bottom-start" isLazy trigger="hover">
            <PopoverTrigger>
              <Text fontSize="sm" color="#A0AEC0" height="100%" flexGrow={1} display="flex" alignItems="center">
                {currentFieldValue?.placeholder || value || 'Placeholder'}
              </Text>
            </PopoverTrigger>
            <PopoverContent boxShadow="xl">
              <PopoverArrow />
              <PopoverBody>
                <Text fontSize="sm">{t('formBuilder.infoTooltips.preview.description')}</Text>
              </PopoverBody>
            </PopoverContent>
          </Popover>
        </HStack>
        {rightContent}
      </Box>
    );
  },
  (prev, next) => prev.value === next.value,
);

InputPreview.displayName = 'InputPreview';
export default InputPreview;
